import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AlertComponent } from '../../components/alert/alert.component';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-ui-toast-host',
  standalone: true,
  imports: [AlertComponent],
  template: `
    <div class="ui-toast-host" aria-live="polite" aria-relevant="additions">
      @for (t of toast.items(); track t.id) {
        <div class="ui-toast-host__item">
          <app-alert
            [type]="t.type"
            [dismissible]="t.dismissible ?? true"
            (dismiss)="toast.dismiss(t.id)"
          >
            {{ t.message }}
          </app-alert>
        </div>
      }
    </div>
  `,
  styles: `
    :host {
      display: contents;
    }
    .ui-toast-host {
      position: fixed;
      right: var(--ui-space-4);
      /* Sit below the app header so toasts don't overlap it. */
      top: calc(var(--app-header-height, 0px) + var(--ui-space-3));
      z-index: var(--ui-z-toast);
      display: flex;
      flex-direction: column;
      gap: var(--ui-space-2);
      max-width: min(24rem, calc(100vw - 2rem));
      pointer-events: none;
    }
    .ui-toast-host__item {
      pointer-events: auto;
      /* Solid base so the floating toast is fully opaque over page content. */
      background: var(--ui-color-surface);
      border-radius: var(--ui-radius-control);
      box-shadow: var(--ui-shadow-md);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiToastHostComponent {
  protected readonly toast = inject(ToastService);
}
